module.exports = __webpack_public_path__ + "img/logo-full.65d94664.png";